export default __webpack_public_path__ + "static/media/google_badge.f902960a.png";